module.exports = __webpack_public_path__ + "img/Apoptosis-NPC_GSE200310.ea39182d.png";